
//Fetch Driver Allocations - table data
export const FETCH_DRIVER_ALLOCATIONS = "driver-allocation/GET_DRIVER_ALLOCATIONS";

/**Fetch DRIVER ALLOCATION DETAILS**/
export const FETCH_DRIVER_ALLOCATION_DETAILS = "driver-allocation/FETCH_DRIVER_ALLOCATION_DETAILS";

/**Fetch DRIVER DETAILS**/
export const FETCH_DRIVER_DETAILS = "driver-allocation/FETCH_DRIVER_DETAILS";


export type Action =
    | { type: FETCH_DRIVER_ALLOCATIONS }
    | { type: FETCH_DRIVER_ALLOCATION_DETAILS }
    | { type: FETCH_DRIVER_DETAILS };


 




// WEBPACK FOOTER //
// ./src/features/relocations/driver/action-types.js